<script>
import RoleEditorView from '@/views/settings/components/RoleEditorView.vue'
import { PermissionHelper } from '@/utils/NewPermissionHelper'
import { asyncRouterMap } from '@/config/router.config'

export default {
  name: 'AllPermission',
  components: { RoleEditorView: RoleEditorView },
  data() {
    return {
      menuTree: []
    }
  },
  created() {
    // 只读展示「项目所有页面权限」，菜单树由页面生成后传入组件
    this.menuTree = PermissionHelper.getPermissionMenuOptions(asyncRouterMap[0].children, [], [])
  },
  methods: {
    updateSetting() {
      const list = this.$refs.roleEditorRef.getTreeOptionsList()
      console.error(list)
      const url = '/permission/v2/editMenusByMerchantType'
      const params = {
        'menuContent': JSON.stringify(list),
        'merchantType': 0
      }
      this.getHttpServices().getPermissionService().post(url, params)
        .then(res => {
          console.log(res)
          this.$message.success('保存成功')
        })
        .catch(err => {
          console.log(err)
          this.$message.error('保存失败，请重试')
        })
    },
    /**
     * 将文本内容下载为 JSON 文件
     * @param {string|object} data - 要导出的数据（对象会自动 JSON.stringify）
     * @param {string} fileName - 文件名，如 'permission.json'
     */
    downloadJsonFile(data, fileName = 'export.json') {
      // 1. 如果传入的是对象，先转成 JSON 字符串（带格式化缩进，方便阅读）
      const jsonStr = typeof data === 'string'
        ? data
        : JSON.stringify(data, null, 2)

      // 2. 创建 Blob 对象，指定 MIME 类型为 JSON
      const blob = new Blob([jsonStr], { type: 'application/json' })

      // 3. 生成一个临时的下载 URL
      const url = URL.createObjectURL(blob)

      // 4. 创建一个隐藏的 <a> 标签，触发下载
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      a.click()

      // 5. 下载完成后，释放临时 URL，避免内存泄漏
      URL.revokeObjectURL(url)
    },
    downloadJson() {
      const list = this.$refs.roleEditorRef.getTreeOptionsList()
      this.downloadJsonFile(JSON.stringify(list), 'MerchantManagementMenus.json')
    }
  }
}
</script>

<template>
  <div class="standard-query-page">
    <div class="title-box">
      <span class="title">项目所有的页面权限</span>
      <span class="tips">提示：新增权限控制页面的时候需要更新</span>
    </div>
    <div class="content-list">
      <RoleEditorView
        ref="roleEditorRef"
        :menu-tree="menuTree"
        :is-role="false"
        :show-back-button="false"
        :show-save-button="false"
      ></RoleEditorView>
      <div class="bt-button-box">
<!--        <a-button type="primary" @click="updateSetting" style="width: 180px">保存</a-button>-->
        <a-button type="primary" @click="downloadJson" style="width: 180px;">下载json文件</a-button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.standard-query-page {
  width: 100%;
  height: 100%;
  flex: 1;
  flex-shrink: 0;

  display: flex;
  flex-direction: column;
  background: white;
  box-sizing: border-box;
  padding: 16px 24px;

  .title-box {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    .title {
      font-size: 22px;
      line-height: 26px;
      font-weight: 600;
    }

    .tips {
      margin-left: 12px;
      font-size: 14px;
      line-height: 14px;
    }
  }

  .content-list {
    width: 100%;
    flex: 1;
    max-height: 100%;
    overflow-y: scroll;
  }

  .bt-button-box {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
